import { Login } from '@apis/Users'
import { setCookie, getCookie, removeCookie } from '@utils/cookie'
import { getToken, setToken, removeToken } from '@utils/auth'
import { uuid } from '@utils'
const state = {
  role: getCookie('role'),
  name: getCookie('name'),
  id: getCookie('id'),
  flag: parseInt(getCookie('flag')),
  token: getToken()
}
const mutations = {
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_ID: (state, id) => {
    state.id = id
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_FLAG: (state, flag) => {
    state.flag = flag
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  }
}
const actions = {
  // 用户登录
  login ({ commit }, loginForm) {
    const { username, password } = loginForm
    return new Promise((resolve, reject) => {
      Login({ userName: username.trim(), pwd: password, uuid: uuid() })
        .then(res => {
          const { data } = res
          commit('SET_ROLE', data.roleid)
          commit('SET_NAME', data.username)
          commit('SET_ID', data.id)
          commit('SET_TOKEN', data.token)
          commit('SET_FLAG', 1)
          setCookie('flag', 1)
          setCookie('role', data.roleid)
          setCookie('name', data.username)
          setCookie('id', data.id)
          setToken(data.token)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginmeter ({ commit }, loginForm) {
    const { username, password } = loginForm
    return new Promise((resolve, reject) => {
      Login({ userName: username.trim(), pwd: password, uuid: uuid() })
        .then(res => {
          const { data } = res
          commit('SET_ROLE', data.roleid)
          commit('SET_NAME', data.username)
          commit('SET_ID', data.id)
          commit('SET_TOKEN', data.token)
          commit('SET_FLAG', 2)
          setCookie('flag', 2)
          setCookie('role', data.roleid)
          setCookie('name', data.username)
          setCookie('id', data.id)
          setToken(data.token)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 用户登出
  logout ({ commit }) {
    return new Promise((resolve) => {
      commit('SET_ROLE', '')
      commit('SET_ID', '')
      commit('SET_NAME', '')
      commit('SET_TOKEN', '')
      commit('SET_FLAG', '')
      removeCookie('flag')
      removeCookie('role')
      removeCookie('name')
      removeCookie('id')
      removeToken()
      resolve()
    })
  },
  logoutmeter ({ commit }) {
    return new Promise((resolve) => {
      commit('SET_ROLE', '')
      commit('SET_ID', '')
      commit('SET_NAME', '')
      commit('SET_TOKEN', '')
      commit('SET_FLAG', '')
      removeCookie('flag')
      removeCookie('role')
      removeCookie('name')
      removeCookie('id')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
